module.exports = __webpack_public_path__ + "img/product1.95e2fe35.png";